import { FileCode } from 'lucide-react';
import LlmsTxtForm from '../../../components/LlmsTxtForm';
import InfoTip from '../../../components/InfoTip';

export default function LlmsTxtSection({ domain }) {
  return (
    <div className="card">
      <div className="section-header">
        <div className="section-title">
          <span className="section-icon">
            <FileCode className="w-4 h-4" />
          </span>
          llms.txt
          <InfoTip
            title="What is llms.txt?"
            body="A plain-text file at your site root (like robots.txt, but for LLMs) that tells AI engines which pages matter most, which to ignore, and how to describe your site. Emerging standard — adopted by Anthropic, Stripe, Vercel, and growing. It won't hurt if engines ignore it; it helps the ones that respect it."
          />
        </div>
      </div>
      <p className="text-sm text-gray-600 mb-3">
        Auto-generated from your audit + AI traffic. Serve it at{' '}
        <code>https://{domain.domain}/llms.txt</code> so AI crawlers know what to
        prioritize.
      </p>
      <div className="bg-gray-50 border border-gray-100 rounded-xl p-4 mb-4 text-xs space-y-3">
        <div>
          <div className="font-semibold text-ink-700 mb-1">
            Option 1: Reverse-proxy from your CDN to:
          </div>
          <code className="select-all break-all">
            {import.meta.env.VITE_API_URL || ''}/public/llms-txt/{domain.domain}
          </code>
        </div>
        <div>
          <div className="font-semibold text-ink-700 mb-1">
            Option 2: Cron-fetch the raw content and serve it yourself:
          </div>
          <code className="select-all break-all">
            curl {import.meta.env.VITE_API_URL || ''}/api/domains/{domain._id}/llms-txt/raw -H &quot;Authorization: Bearer YOUR_TOKEN&quot; &gt; llms.txt
          </code>
        </div>
      </div>
      <LlmsTxtForm domainId={domain._id} domainHost={domain.domain} />
    </div>
  );
}
